import React from "react";
import S from "gui/Components/ScreenHeader/ScreenHeaderPusher.module.scss";

export class ScreenHeaderPusher extends React.Component {
  render() {
    return <div className={S.root} />;
  }
}
